import logo from './logo.svg';
import './App.css';
import CsvUploader from './component/CsvUploader';

function App() {
  return (
    <div className="App">
      <CsvUploader/>
    </div>
  );
}

export default App;
